/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'
/* global expocadfx PDFDocument blobStream */


expocadfx.pdfOutput = function( failedCallback) {
    var config = expocadfx.config;
    var data = expocadfx.fxData;
	var load = expocadfx.loadScript;
	var pdfDoc = null;
	var callback = failedCallback;
	
	var pendingOverlays = data.arOverlays.length;
	var overlay = null;

	var pAdjX = 0;
	var pAdjY = 0;
	var pOrientation = "landscape";	
	var pdfScale = 0.045833;

	// Set these based on print layout values generated from EXPOCAD when creating the FX files
	if(!config.hasMultipleViews){

		pAdjX = parseInt(config.printLayoutAdjustmentX);
		pAdjY = parseInt(config.printLayoutAdjustmentY);
		pdfScale = config.printLayoutScale;

		if (config.printLayoutOrientation == 1){
			pOrientation = "portrait";
		}
	}



	if( typeof( window.blobStream) === "undefined") {
		
		var path = "../util/blob-stream-min.js";

		if(config.isXML){
			path = "blob-stream-min.js";
		}

		load( path, blobstreamCallback, true);
	}
	else {
		checkPdfKit();
	}
	
	function blobstreamCallback( success) {
		if( success) {
			checkPdfKit();
		}
		else {
			data.pdfOk = false;
			callback( true);		// true for full floor plan
		}
	}
	
	function checkPdfKit() {
		if( typeof( window.PDFDocument) === "undefined") {
			load( "pdfkit-min.js", pdfkitCallback, true);
		}
		else {
			makePDF();
		}
	}
	
	function pdfkitCallback( success) {
		if( success) {
			
			PDFDocument.prototype.arc = function(x, y, radius, startAngle, endAngle, anticlockwise) {
				var startX = Number(x) + Number(radius * Math.round( Math.cos(startAngle)));
				var startY = Number(y) + Number(radius * Math.round( Math.sin(startAngle)));

				var endX = Number(x) + radius * Math.round( Math.cos(endAngle));
				var endY = Number(y) + radius * Math.round( Math.sin(endAngle));
				
				var arcAngle = endAngle - startAngle;
				var largeArc = (arcAngle > Math.PI) ^ (startAngle > endAngle) ^ anticlockwise;
				var path =
					"M "+startX+","+startY+
					" A "+radius+","+radius+
					" 0 "+(largeArc?"1":"0")+","+(anticlockwise?"0":"1")+
					" "+endX+","+endY;

				return this.path(path);
			};
			
			makePDF();
		}
		else {
			data.pdfOk = false;
			callback( true);
		}
	}
	
	function makePDF() {
		var src = (config.hasMultipleViews && config.hasFloorPlan) ?
				config.viewName + ".jpg" : config.eventName + ".jpg";

		pdfDoc = new PDFDocument( { layout: pOrientation});


		var stream = pdfDoc.pipe( blobStream());

		stream.on('finish', function() {
			if( window.navigator.msSaveOrOpenBlob) {
				var blobObj = stream.toBlob('application/pdf');
				window.navigator.msSaveOrOpenBlob( blobObj);
			}
			else {
				window.open( stream.toBlobURL('application/pdf'));
			}
			stream = null;
		});

		//pdfDoc.scale( 0.045833);

		pdfDoc.scale(pdfScale);

		sendRequest( src, loadedBuilding);
	}
    
	function loadedBuilding( req) {
				
		//pdfDoc.image( req.response, 0, 0, {width: config.DRAWING_WIDTH,height: config.DRAWING_HEIGHT});
		pdfDoc.image( req.response, 0 - pAdjX, 0 - pAdjY, {width: config.DRAWING_WIDTH,height: config.DRAWING_HEIGHT});
		
		//  technical layers ??
		data.arTechLayers.forEach( function( group) {
			if( group.visible) {
				group.graphics.forEach( function( graphic) {
					if( graphic.type === "F") {
						pdfBooth( graphic);
					}
					else if( graphic.type === "C") {
						pdfDoc.circle( graphic.x - pAdjX, graphic.y - pAdjY, Number(graphic.radius))
							.lineWidth( graphic.lineWidth)
							.strokeColor(graphic.strokeColor)
							.stroke();
					}
					else {
						pdfDoc.strokeColor( graphic.strokeColor);
						pdfDoc.lineWidth( graphic.lineWidth);

						pdfDoc.arc( graphic.x - pAdjX, graphic.y - pAdjY, graphic.radius,
											graphic.startAngle, graphic.endAngle,
											graphic.anticlockwise).stroke();
					}
				});
				group.txt.forEach( function( txt) {
					pdfText( txt);
				});
			}
		});
		
		data.buildingText.forEach( function( txt) {
			pdfText( txt);
		});
		if( data.addedGraphics) {
			data.addedGraphics.graphics.forEach( function( graphic) {
				if( graphic.type === "C") {
					pdfDoc.circle( graphic.x - pAdjX, graphic.y - pAdjY, Number(graphic.radius))
						.lineWidth( graphic.lineWidth)
						.strokeColor( graphic.strokeColor)
						.stroke();
				}
				else if( graphic.type === "A") {
					pdfDoc.save();
					pdfDoc.strokeColor( graphic.strokeColor);
					pdfDoc.lineWidth( graphic.lineWidth);

					pdfDoc.arc( graphic.x - pAdjX, graphic.y - pAdjY, graphic.radius, graphic.startAngle, graphic.endAngle, graphic.anticlockwise).stroke();
					pdfDoc.restore();
				}
				else {
					pdfBooth( graphic);
				}
			});
			data.addedGraphics.txt.forEach( function( txt) {
				pdfText( txt);
			});

		}
		data.pavilions.forEach( function( pavilion) {
			pdfBooth( pavilion);
		});
		
		data.boothGraphics.forEach( function( bth) {
			pdfBooth( bth);
		});
			//  ADD OVERLAYS before booth and pavilion text
		if( data.arOverlays.length > 0) {
			document.addEventListener( "PDF_IMAGE_D0NE", imageDone);
			addAnOverlay();
		}
		else {
			addText();
		}
	}
	
		//  Add booth text after overlays
	function addText() {
		// need favorites and selected first !
		
		data.favoriteMarks2d.forEach( function( mark) {
//			if( mark.text) {
				var tmpText = mark.text;
				//////// attempt to get some special character for 'fav' pdf splits 16-bit code into 2 8-bit
//				pdfDoc.save();
//				pdfDoc.font('Symbol');
				mark.text = "FAV";
				pdfText( mark);
//				console.log( mark.text);
				pdfDoc.restore();
				mark.text = tmpText;
				//"FAV";  // String.fromCharCode( 0x263C);
				// example from mozilla  String.fromCodePoint(9731, 9733, 9842, 0x2F804); works in console!
				//  String.fromCodePoint( 0x2014)   String.fromCharCode( 0x2665);  // "♥"; 
//			}
		});
		
		data.selected2d.forEach( function (selected) {
			pdfDoc.circle( selected.x - pAdjX, selected.y - pAdjY, selected.radius)
				.lineWidth(16)
				.strokeColor( config.clrSelected)
				.stroke();
		});
		
		data.boothGraphics.forEach( function( bth) {
			if( bth.text.length > 0) {
				bth.text.forEach( function( txt) {
					pdfText( txt);
				});
			}
			if( bth.dimensionText.length > 0 && config.showDimensions == true) {
				bth.dimensionText.forEach( function( txt) {
					pdfText( txt);
				});
			}
		});
		
		data.pavilionLabels.forEach( function( txt) {
			pdfText( txt);
		});
		
		data.floorPlanText.forEach( function( txt) {
			pdfText( txt);
		});
		document.removeEventListener( "PDF_IMAGE_D0NE", imageDone);
		pdfDoc.end();
		pdfDoc = null;
	}
		
	function addAnOverlay() {
		if( pendingOverlays > 0) {
			pendingOverlays -= 1;
			overlay = data.arOverlays[ pendingOverlays];
			
			if( overlay.ready) {
				overlay.req = new XMLHttpRequest();
				overlay.req.onreadystatechange = function() {
					if( this.readyState === 4 && this.status === 200) {
						loadedOverlayFile();
					}
				};

				overlay.req.open( "GET", overlay.source);
				overlay.req.responseType = "arraybuffer";
				overlay.req.send();
			}
			else {
				if( pendingOverlays === 0) {
					addText();
				}
				else {
					addAnOverlay();
				}
			}
		}
	}
	
	function loadedOverlayFile() {
		pdfDoc.image( overlay.req.response, overlay.x - pAdjX, overlay.y - pAdjY, {width: overlay.w,height: overlay.h});
		overlay.req = null;
		overlay = null;
		
//		setTimeout( overlayDelay, 300);
	}
	
	function overlayDelay() {
		if( pendingOverlays === 0) {
			addText();
		}
		else {
			addAnOverlay();
		}
	}
	
	function imageDone() {
		setTimeout( overlayDelay, 1);		// make sure pdfKit has finished
	}
	
	function pdfBooth( bth) {
		var len = 0;
		var i = 0;
		
		if( !bth.path || bth.path.length === 0) {
//			console.log( "NO PATH FOR BOOTH  " + bth.number + "  type: " + bth.type + "  status: " +
//					   data.booths[ bth.index].status);
			return;
		}
		len = bth.path.length;
		
		pdfDoc.moveTo( bth.path[0].x - pAdjX, bth.path[0].y - pAdjY);
		
		for( i = 1; i < len; i++) {
			pdfDoc.lineTo( bth.path[i].x - pAdjX, bth.path[i].y - pAdjY);
		}
		pdfDoc.lineTo( bth.path[0].x - pAdjX, bth.path[0].y - pAdjY);
		pdfDoc.strokeColor(bth.strokeColor);
		pdfDoc.fillColor(bth.fillColor);
		pdfDoc.fillOpacity( bth.alpha);
		
		if( bth.type === "T") {
			pdfDoc.fillAndStroke();
		}
		else if( bth.type === "F") {
			pdfDoc.stroke();
		}
		else {
			pdfDoc.fill();
		}
	}
	
	function pdfText( txt) {
		var strLen = 0;
		pdfDoc.save();
		
		pdfDoc.fontSize( Math.min( txt.fontSize, 630));
		strLen = pdfDoc.widthOfString( txt.text);
		
		var offX = -0.5 * strLen;
		var offY = -0.3 * txt.fontSize;
		
		pdfDoc.fillColor( txt.fill);
		pdfDoc.translate( txt.x - pAdjX, txt.y - pAdjY);
		if( txt.dRot !== 0) {
			pdfDoc.rotate( txt.dRot);
		}
		var tw = 100 + strLen;
		pdfDoc.text( txt.text, offX, offY, { width:tw});
		pdfDoc.translate( 0, 0);
		
		pdfDoc.restore();
	}
    
    function sendRequest( reqString, callback) {	// requestMethod, responseType
        var req = new XMLHttpRequest();
        req.open( 'GET', reqString, true);
        req.onload = function() {
            if( req.readyState === 4 && req.status === 200) {
                callback( this);
            }
        };
		
        req.responseType = 'arraybuffer';
        req.send();
    }
	
};